export const isNotNullOrUndefined = <T>(
  value: T | undefined | null,
): value is T => undefined !== value && null !== value;

export const isNotUndefined = <T>(value: T | undefined): value is T =>
  undefined !== value;
